/**
 * lucide-react v0.241.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const Info = createLucideIcon("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);

export { Info as default };
//# sourceMappingURL=info.js.map
